/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRootPagePlay = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 22.2V11.8l9 5.2zm2-7v3.5l3-1.8zM11 22H3V2h11.4L21 8.6V13h-2V9.4L13.6 4H5v16h6zm-2.1-4.5-1.7-1 2-3.5H7v-2h5.8z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgRootPagePlay as RootPagePlay };
